import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const getInvoiceDocumentRouteBase = (invoiceDocumentType: InvoiceDocumentType) => {
  switch (invoiceDocumentType) {
    case InvoiceDocumentType.Invoice:
    case InvoiceDocumentType.InvoiceDraft:
    case InvoiceDocumentType.CreditNote:
      return 'invoices'
    case InvoiceDocumentType.Quote:
    case InvoiceDocumentType.QuoteDraft:
      return 'quotes'
    case InvoiceDocumentType.RecurringInvoice:
    case InvoiceDocumentType.RecurringInvoiceDraft:
      return 'recurring-invoices'

    // invoiceDocumentRouteBases listed below are going to be supported in the future

    // case InvoiceDocumentType.DeliveryNote:
    // case InvoiceDocumentType.DeliveryNoteDraft:
    //   return 'delivery-notes'
    // case InvoiceDocumentType.Receipt:
    // case InvoiceDocumentType.ReceiptDraft:
    //   return 'receipts'
    default:
      return 'invoices'
  }
}
